import { call, put, takeEvery } from 'redux-saga/effects';
import { ProgramActionKeys, programsActionCreators, UpdateProgramLevel } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';
import { IProgramLevel } from '../programsInterfaces';

function* updateProgramLevelSaga(action: UpdateProgramLevel) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IProgramLevel> = yield call(api.updateProgramlevel, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(programsActionCreators.setProgramLevels([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateProgramLevel() {
  yield takeEvery(ProgramActionKeys.UPDATE_PROGRAM_LEVEL, updateProgramLevelSaga);
}
